import { useRequest } from 'ahooks'

import { http } from '@/utils'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'
// 紧急联系人 添加/编辑
export const saveContact = (data: any): any => http.post('/hrm/contact', data)
// 紧急联系人 批量删除
export const deleteHrmContact = (data: any) => http.delete('/hrm/contact', { data })
export default ({ value, onConfirm }: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  // const staffId = decodeURIComponent(getQuery('staffId') || '')

  // 紧急联系人 添加/编辑
  const { run: runSaveContact, loading: saveContactLoading } = useRequest(saveContact, {
    manual: true,
    onSuccess: (result: any) => {
      const { code } = result
      if (code === 2000) {
        onCancel()
        onConfirm()
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
    }
  })

  // 紧急联系人 批量删除
  const { run: runDeleteHrmContact, loading: deleteHrmContactLoading } = useRequest(
    deleteHrmContact,
    {
      manual: true,
      onSuccess: (result: any) => {
        const { code } = result
        if (code === 2000) {
          onCancel()
          onConfirm()
        }
      },
      onError: ({ message }) => {
        console.log('error', message)
      }
    }
  )
  const add = () => {
    onOpen({ status: 'Add', editItem: {} })
  }

  const edit = (index: number) => {
    onOpen({ status: 'Edit', editItem: value?.[index] || {} })
  }

  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runDeleteHrmContact,
    runSaveContact,
    deleteHrmContactLoading,
    saveContactLoading
  }
}
